import { z } from "zod";

export interface PartyProcessApiConfig {
	baseUrl: string;
}

export function loadPartyProcessApiConfig(): PartyProcessApiConfig {
	const env = validateEnvironment();
	return {
		baseUrl: env.PARTY_PROCESS_API
	};
}

function validateEnvironment() {
	const envSchema = z.object({
		PARTY_PROCESS_API: z.string({
			required_error: "PARTY_PROCESS_API environment variable is missing"
		})
	});

	const parsed = envSchema.safeParse(process.env);

	if (!parsed.success) {
		throw new Error(parsed.error.errors.map((e) => e.message).join("\n"));
	}

	return parsed.data;
}
